// extracted by mini-css-extract-plugin
module.exports = {"label":"label-2HIWmFG","content":"content-LGr1zav","mdash":"mdash-JZvfvvY"};